import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Divider, Typography } from '@mui/material';
import { UpdateProductTabProps } from '../../../interfaces/Product/UpdateProductTab';
import { getEmptyProductMedia } from '../../../interfaces/Product/ProductMedia';
import { getProductMedia, updateProductMedia } from '../../../api/ProductMedia';
import { ProductMediaOptions } from '../../../interfaces/Product/ProductMediaOptions';
import { sharedStyles } from '../../../utils/Style';
import { Waiting } from '../../../components/Waiting/Waiting';
import { VideoUrlInput } from '../../../components/VideoUrlInput/VideoUrlInput';
import { ImageInput } from '../../../components/ImageInput/ImageInput';

export const UpdateProductMedia = (props: UpdateProductTabProps) => {
  const [loading, setLoading] = useState(false);
  const [media, setMedia] = useState(getEmptyProductMedia());

  useEffect(() => {
    setLoading(true);
    getProductMedia(props.productID)
      .then((m) => setMedia(m))
      .catch((err) => toast.error(err))
      .finally(() => setLoading(false));
  }, []);

  const handleUpdateMedia = (options: ProductMediaOptions) => {
    setLoading(true);
    updateProductMedia(props.productID, options)
      .then((m) => {
        toast.success('Medya başarıyla güncellendi');
        setMedia(m);
      })
      .catch((err) => toast.error(err))
      .finally(() => setLoading(false));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mt: 1.5,
        gap: 1.5,
      }}
    >
      <Waiting open={loading} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 1.5,
        }}
      >
        <ImageInput
          title='Kapak Fotoğrafı'
          existingImage={media.coverImage}
          enableEnhancement
          onUpload={(file) => handleUpdateMedia({ image: file })}
          onDelete={() => handleUpdateMedia({ eraseImage: true })}
        />

        <VideoUrlInput
          title='Video'
          enableYoutubePreview
          url={media.videoURL}
          onSubmit={(newUrl) =>
            handleUpdateMedia({ videoURL: newUrl, eraseVideo: !newUrl })
          }
        />
      </Box>

      <Typography sx={{ ...sharedStyles.h5, mt: 1.5 }}>Ek Resimler</Typography>
      <Divider />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 1.5,
        }}
      >
        {media.additionalImages.map((image, index) => (
          <ImageInput
            key={index}
            title={`Resim ${index + 1}`}
            existingImage={image}
            enableEnhancement
            onUpload={(file) => handleUpdateMedia({ image: file, index })}
            onDelete={() => handleUpdateMedia({ eraseImage: true, index })}
          />
        ))}

        <ImageInput
          key={media.additionalImages.length}
          title='Yeni Resim'
          enableEnhancement
          onUpload={(file) =>
            handleUpdateMedia({
              image: file,
              index: media.additionalImages.length,
            })
          }
        />
      </Box>
    </Box>
  );
};
